import { AxiosError } from 'axios';
import { logInfo } from 'utils/logging';
import { getCSRFTOKEN } from 'utils/cookie/getCSRFToken';
import { axiosAPI } from 'lib/api';

type PostReportResponse = {
  success: boolean;
  error?: string;
};

const postReport = async (
  type: 'questions' | 'answers',
  data: string | number,
): Promise<PostReportResponse> => {
  const csrf_token = getCSRFTOKEN('OTVETY-CSRF-TOKEN') || '';
  try {
    return await axiosAPI({
      url: `/otvety/api/${type}/${data}/complain`,
      method: 'POST',
      headers: {
        'X-CSRF-TOKEN': csrf_token,
      },
    });
  } catch (error) {
    const e = error as AxiosError;
    logInfo(e.toString(), true);
    return { success: false, error: 'error' };
  }
};

export default postReport;
